





























































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import {
  IMember,
  IMemberCreateRequest,
  IMemberRequest,
  IMemberUpdateRequest,
} from "@/types/member";
import { ISalesListRequest } from "@/types/sales";
import { ISelectItem } from "@/types";
import { MemberRequest, MemberUpdateRequest } from "@/models/member";
import ImageUpload from "@/components/imageUpload.vue";
import { IProceed, IProceedListRequest } from "@/types/proceed";

@Component({
  components: {
    ImageUpload,
  },
})
export default class extends Vue {
  @Action("member/adminGet")
  public getMember!: (member_id: number) => Promise<void>;

  @Action("member/adminCreate")
  public create!: (params: IMemberCreateRequest) => Promise<boolean>;

  @Action("employment/getList")
  public getEmploymentList!: (params: ISalesListRequest) => Promise<boolean>;

  @Getter("employment/selectItem")
  public employmentList!: ISelectItem[];

  @Action("department/getList")
  public getDepartmentList!: (params: ISalesListRequest) => Promise<boolean>;

  @Getter("department/selectItem")
  public departmentList!: ISelectItem[];

  @Action("skill/getList")
  public getSkillList!: (params: ISalesListRequest) => Promise<boolean>;

  @Getter("skill/selectItem")
  public skillList!: ISelectItem[];

  @Action("sales/adminGetList")
  public getSaleList!: (params: ISalesListRequest) => Promise<boolean>;

  @Getter("sales/selectItem")
  public salesList!: ISelectItem[];

  @Action("member/adminUpdate")
  public update!: (data: {
    member_id: number;
    params: IMemberUpdateRequest;
  }) => Promise<boolean>;

  @Action("member/adminDelete")
  public deleteMember!: (member_id: number) => Promise<boolean>;

  @Getter("member/single")
  public member!: IMember;

  @Action("proceed/salesGetList")
  public getProceeds!: (params: IProceedListRequest) => Promise<void>;

  @Getter("proceed/memberProceeds")
  public memberProceeds!: IProceed[];

  @Action("member/isUniqueEmail")
  public isUniqueEmail!: (email: string) => boolean;

  public birthday = false; // 生年月日モーダル
  public passwordShow = false;
  public passwordChange = false;
  public qualificationShow = [false, false, false];
  public deleteDialogShow = false;
  public email_errors: string[] = [];

  public uploadedImageUrl = "";

  public member_id = 0;

  public params: IMemberRequest = new MemberRequest();

  public rules = {
    name: [(v: number): boolean | string => !!v || "名前は必須です"],
    kana: [
      (v: number): boolean | string => !!v || "名前（カナ）は必須です",
      (v: string): boolean | string =>
        !v || /^[\u30A0-\u30FF]+$/.test(v) || "カタカナで入力してください",
    ],
    nickname: [(v: number): boolean | string => !!v || "表示名は必須です"],
    birthday: [(v: number): boolean | string => !!v || "生年月日は必須です"],
    image: [
      (v: File): boolean | string =>
        !v || v.size < 2000000 || "ファイルサイズの上限は2MBです",
    ],
    email: [
      (v: string): boolean | string =>
        !!v || "ログイン用メールアドレスは必須です",
      (v: string): boolean | string =>
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          v
        ) || "正しいメールアドレスを入力してください",
    ],
    password: [
      (v: string): boolean | string => !!v || "パスワードは必須です",
      (v: string): boolean | string =>
        /^[a-zA-Z0-9]+$/.test(v) || "半角英数字で入力してください",
      (v: string): boolean | string =>
        /^.{8,}$/.test(v) || "8文字以上を入力してください",
    ],
    employment_id: [
      (v: number): boolean | string => !!v || "雇用形態は必須です",
    ],
    department_id: [(v: number): boolean | string => !!v || "部門は必須です"],
    qualification: [],
  };

  private async created() {
    this.member_id = Number(this.$route.params.member_id);

    await Promise.all([
      this.getSaleList({ per_page: 0 }),
      this.getDepartmentList({ per_page: 0 }),
      this.getEmploymentList({ per_page: 0 }),
      this.getSkillList({ per_page: 0 }),
      this.getProceeds({ per_page: 0 }),
    ]);

    if (this.member_id) {
      await this.getMember(this.member_id);

      this.params = new MemberUpdateRequest(this.member);
      if (this.member.attachment) {
        this.uploadedImageUrl = this.member.attachment.url;
      }
    }
  }

  public member_confirm() {
    this.deleteDialogShow = true;
  }

  public async member_delete() {
    await this.deleteMember(this.member_id);
    this.$router.push("/sales/member");
  }

  public onFileChanged(base64: string): void {
    this.params.upload_file = base64;
    this.uploadedImageUrl = base64;
  }

  public employmentChanged(employment_id: number) {
    this.params.progress = this.memberProceeds
      .filter(
        (proceed) =>
          !proceed.employment_id || proceed.employment_id == employment_id
      )
      .map((proceed) => proceed.name);
  }

  public async submit() {
    let result = false;

    if (!this.member_id) {
      result = await this.create(this.params as IMemberCreateRequest);
    } else {
      result = await this.update({
        member_id: this.member_id,
        params: this.params as IMemberUpdateRequest,
      });
    }
    if (result) {
      this.$router.back();
    }
  }

  // Emailの二重登録チェック
  public async emailValidate() {
    // 登録時
    if (!(await this.isUniqueEmail(this.params.email)) && !this.member.email) {
      return (this.email_errors = ["既に使用されています"]);
    }

    // 編集時
    if (
      !(await this.isUniqueEmail(this.params.email)) &&
      this.member.email != this.params.email
    ) {
      return (this.email_errors = ["既に使用されています"]);
    }

    return (this.email_errors = []);
  }
}
